import { createBrowserRouter } from 'react-router-dom';

import RoleSpecificRoute from '@components/guards/RoleSpecificRoute';
import Layout from '@components/layout/Layout';

import ActivateUser from './ActivateUser';
import AdminList from './AdminList';
import CustomersList from './CustomersList';
import EmailSettings from './EmailSettings';
import Login from './Login';
import NotFound from './NotFound';
import PasswordReset from './PasswordReset';
import PasswordResetRequest from './PasswordResetRequest';
import Register from './Register';
import UserDetail from './UserDetail';
import SearchStatistics from './SearchStatistics';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: 'registrati',
        element: <Register />,
      },
      {
        path: 'password-reset',
        element: <PasswordResetRequest />,
      },
      {
        path: 'password-reset/:token',
        element: <PasswordReset />,
      },
      {
        path: 'users/activate/:token',
        element: <ActivateUser />,
      },
      {
        path: 'clienti',
        element: (
          <RoleSpecificRoute roles={['admin']} element={<CustomersList />} />
        ),
      },
      {
        path: 'amministratori',
        element: (
          <RoleSpecificRoute roles={['admin']} element={<AdminList />} />
        ),
      },
      {
        path: 'utenti/:id',
        element: (
          <RoleSpecificRoute roles={['admin']} element={<UserDetail />} />
        ),
      },
      {
        path: 'impostazioni-email',
        element: (
          <RoleSpecificRoute roles={['admin']} element={<EmailSettings />} />
        ),
      },
      {
        path: 'statistiche-ricerche',
        element: (
          <RoleSpecificRoute roles={['admin']} element={<SearchStatistics />} />
        ),
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);

export default router;
